import { render, staticRenderFns } from "./SettingsSecurityCourseList.vue?vue&type=template&id=b1c642fc&scoped=true"
import script from "./SettingsSecurityCourseList.vue?vue&type=script&lang=js"
export * from "./SettingsSecurityCourseList.vue?vue&type=script&lang=js"
import style0 from "./SettingsSecurityCourseList.vue?vue&type=style&index=0&id=b1c642fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c642fc",
  null
  
)

export default component.exports